import React, { useContext } from "react";
import { LogOut, ShieldAlert } from "lucide-react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Button } from "../ui/button";

const ImpersonateBanner = () => {
	const { isImpersonating, user, handleStopImpersonate } = useContext(AuthContext);

	if (!isImpersonating) {
		return null;
	}

	return (
		<div className="bg-amber-500 text-amber-950 dark:bg-amber-600 dark:text-amber-50 px-4 py-2 flex flex-wrap items-center justify-between gap-2 shadow-sm text-sm font-medium sticky top-0 z-50">
			<div className="flex items-center gap-2 min-w-0">
				<ShieldAlert className="h-4 w-4 shrink-0" />
				<span className="truncate">
					Modo de Suporte: Você está conectado como <strong>{user?.name || "Usuário"}</strong> ({user?.email})
				</span>
			</div>
			<Button
				variant="outline"
				size="sm"
				onClick={handleStopImpersonate}
				className="bg-white/90 dark:bg-slate-900/90 hover:bg-white border-amber-600 text-amber-900 dark:text-amber-100 h-8 gap-1.5 shrink-0"
			>
				<LogOut className="h-3.5 w-3.5" />
				<span>Voltar à minha conta</span>
			</Button>
		</div>
	);
};

export default ImpersonateBanner;
